<template>
  <div class="gray_block">
    <div>
      <div class="inner_gray_block">
        <h3>Urmatoarele informatii trebuie sa fie vizibile</h3>
        <span :style="{ color: descriptionTextColor }"
          >{{descriptionText}}</span
        >
      </div>
      <div class="align-items-center mobile-helper">
        <div class="col-5 col-sm-6 col-md-6 col-lg-5 img">
          <img class="img-fluid" :src="getImgUrl()" alt="" />
        </div>
        <div class="col-7 sm-6 col-md-6 col-lg-7 text">
          <ul class="wraper_punkt">
            <li class="media" :key="step.label" v-for="step in steps">
              <div class="media-body d-flex align-items-center">
                <div class="item_label" :style="{ color: color }">
                  {{ step.label }}
                </div>
                <div class="media-body item_text" :style="{ color: textColor }">
                  {{ step.text }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "receipt-information",
  props: {
    descriptionText: {
      required: false,
      type: String,
      default: ""
    },
    steps: {
      required: false,
      type: [Array, Object],
      default: () => []
    },
    color: {
      default: "808080"
    },
    descriptionTextColor: {
      default: "#0f2967"
    },
    textColor: {
      default: "#0f2967"
    },
    receiptImage: {
      required: false,
      type: String,
      default: "receipt"
    },
    receiptIsSvg: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getImgUrl() {
      var images = "";
      if(this.receiptIsSvg === true) {
        images = require.context("../../assets/images/svg", false, /\.svg$/);
        return images(`./${this.receiptImage}.svg`);
      } else {
        images = require.context("../../assets/images/png", false, /\.png$/);
        return images(`./${this.receiptImage}.png`);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
* {
  font-family: "Plus Jakarta Sans";
}

.desc-text {
  text-align: left;
  font-size: 18px;
}

.gray_block {
  padding: 60px 0px 0px 60px;
  border-radius: 4px;
  @media (max-width: 991px) {
    padding: 40px 60px;
  }
  @media (max-width: 767px) {
    padding: 40px 0;
  }
  .inner_gray_block {
    margin-bottom: 50px;
  }
}
.wraper_punkt {
  margin-bottom: 30px;
  li {
    margin-bottom: 30px;
    font-size: 16px;
    letter-spacing: 0.16px;
    line-height: 19px;
    @media (max-width: 991px) {
      margin-bottom: 15px;
    }
    .item {
      width: 25px;
      height: 25px;
      display: inline-block;
      background: #8b8b8b;
      color: #ffffff;
      border-radius: 100px;
      text-transform: uppercase;
      margin-right: 20px;
      text-align: center;
      padding: 3px 8px;
    }
    .item_text {
      font-size: 16px;
      // color: #0f2967;
      font-weight: 400;
      display: inline-block;
    }
    .item_label {
      font-weight: 700;
      font-size: 14px;
      line-height: 26px;
      // color: #f2ac29;
      padding-right: 15px;
    }
  }
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.drop_down {
  display: flex;
  justify-content: space-evenly;
  align-content: center;
  align-items: center;
  cursor: pointer;

  p {
    margin: 0px;

    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
  }

  img {
    width: 20px;
    height: 20px;
  }
}

.drop_down_wrapper {
  padding: 10px !important;
  // border-radius: 100px;
  margin-bottom: 20px !important;
}

@media all and (orientation: landscape) {
  .drop_down {
    display: flex;
    justify-content: space-evenly;
    align-content: center;
    align-items: center;
    cursor: pointer;

    p {
      margin: 0px;

      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
    }

    img {
      width: 20px;
      height: 20px;
    }
  }

  .drop_down_wrapper {
    padding: 10px !important;
    border-radius: 100px;
    margin-bottom: 20px !important;
  }
  @media screen and (max-width: 425px) {
    .stepCardWrapper {
      padding: 15px !important;
      margin-bottom: 200px !important;
      border-radius: 30px;
      height: 450px;
      background-color: white !important;
    }
    .drop_down {
      display: none;
    }
  }
  @media screen and (max-width: 375px) {
    .stepCardWrapper {
      font-size: 12px !important;
    }
  }
}
.mobile-helper {
  display: flex;
  flex-direction: row;
  margin: 0 !important;
  padding: 0 !important;
  @media (max-width: 425px) {
    width: 100%;
    max-width: 350px;
    .media {
      margin-bottom: 15px !important;
      max-width: 180px !important;
      min-width: 180px !important;
    }
    .img {
      width: 100%;
      max-width: 150px !important;
      min-width: 150px !important;
      margin-left: -45px !important;
      margin-right: 65px;
      img{
        min-width: 220px !important;
      }
    }
    .text {
      width: 100%;
      min-width: 150px !important;
      max-width: 200px !important;
      .item_text {
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 19px; /* 158.333% */
      }
    }
  }
  @media (max-width: 375px) {
    width: 100%;
    max-width: 350px;
    .media {
      margin-bottom: 5px !important;
      max-width: 170px !important;
      min-width: 170px !important;
    }
    .img {
      width: 100%;
      max-width: 150px !important;
      min-width: 150px !important;
      margin-left: -45px !important;
      margin-right: 25px;
      img{
        min-width: 190px !important;
      }
    }
    .text {
      width: 100%;
      min-width: 150px !important;
      max-width: 180px !important;
      .item_text {
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 19px; /* 158.333% */
      }
    }
  }
}
</style>
